import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { SITE_SURVEYS_GROUPED_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/site_surveys_grouped_actions';

const initialState: any = standardInitialStateGenerator(['IndexPage']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState, [
	'title',
	'templateId',
]);
